(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Nav light-mode switch when the PDP section (#shop) is in view.
     Ported verbatim from source HTML <script>, plus a null-guard so this
     no-ops on templates other than the homepage (where #shop doesn't exist). */
  (function () {
    var nav = document.getElementById('nav');
    var shop = document.getElementById('shop');
    if (!nav || !shop) return;
    function update() {
      var rect = shop.getBoundingClientRect();
      if (rect.top < 80 && rect.bottom > 80) nav.classList.add('light');
      else nav.classList.remove('light');
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  /* Live local-time clock in the header. Visitor's own clock via new Date();
     no server time, no timezone logic. Renders immediately (no empty flash),
     then updates every second. */
  (function () {
    var clock = document.querySelector('#nav .nav-clock');
    if (!clock) return;
    var dayEl = clock.querySelector('.clock-day');
    var timeEl = clock.querySelector('.clock-time');
    var DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var d = new Date();
      dayEl.textContent = DAYS[d.getDay()];
      timeEl.textContent = pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nightfuel-faq"] && !Shopify.designMode) return;
  try {
    
  /* FAQ accordion. q.closest('.faq-item') instead of q.parentElement so the
     traversal works regardless of whether the button is wrapped in an <h3>
     (a11y accordion pattern) or any other future intermediate element. */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      if (!item) return;
      var willOpen = !item.classList.contains('open');
      item.classList.toggle('open');
      q.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nightfuel-pdp"] && !Shopify.designMode) return;
  try {
    
  /* Offer card toggle: radio dot + aria state + hidden selling_plan input */
  document.querySelectorAll('.offer-card').forEach(function(card) {
    function selectCard(target) {
      document.querySelectorAll('.offer-card').forEach(function(c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
        var r = c.querySelector('.offer-radio');
        if (r) r.classList.remove('is-on');
      });
      target.classList.add('is-selected');
      target.setAttribute('aria-checked', 'true');
      var r = target.querySelector('.offer-radio');
      if (r) r.classList.add('is-on');
      var planInput = document.getElementById('pdp-selling-plan');
      if (planInput) planInput.value = target.dataset.sellingPlanId || '';
    }
    card.addEventListener('click', function() { selectCard(card); });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(card); }
    });
  });

  /* Quantity stepper */
  (function() {
    var minus = document.getElementById('pdp-qty-minus');
    var plus  = document.getElementById('pdp-qty-plus');
    var num   = document.getElementById('pdp-qty-num');
    var val   = document.getElementById('pdp-qty-val');
    if (!minus || !plus || !num) return;
    minus.addEventListener('click', function() {
      var n = parseInt(num.textContent) || 1;
      if (n > 1) { n--; num.textContent = n; if (val) val.value = n; }
    });
    plus.addEventListener('click', function() {
      var n = parseInt(num.textContent) || 1;
      n++; num.textContent = n; if (val) val.value = n;
    });
  })();

  /* PDP accordion is native <details>/<summary> - opens on tap with zero JS,
     so no toggle handler is needed here. */

  /* Thumbnail active state. Source's script only updates the active class  - 
     it doesn't actually swap the main image. Matching source behavior. */
  document.querySelectorAll('.pdp-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.pdp-thumb').forEach(function (x) {
        x.classList.remove('active');
        x.setAttribute('aria-selected', 'false');
      });
      t.classList.add('active');
      t.setAttribute('aria-selected', 'true');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
